import {
  mdiNewspaper,
  mdiMapLegend,
  mdiSchool,
  mdiShieldAccount,
  mdiAccountMultiple,
  mdiCalendar,
  mdiQrcodeScan,
  mdiAccountDetails,
  mdiAccount,
} from '@mdi/js';

export default {
  data() {
    return {
      areaAdminsMenuItems: [
        {
          name: 'menu.adminArticles',
          pathName: 'membership-ListArticles',
          icon: mdiNewspaper,
        },
        {
          name: 'menu.adminScan',
          pathName: 'membership-Scan',
          icon: mdiQrcodeScan,
        },
        {
          name: 'menu.adminMap',
          pathName: 'membership-Areas',
          icon: mdiMapLegend,
        },
        {
          name: 'menu.adminCollege',
          pathName: 'membership-ListCollegeModule',
          icon: mdiSchool,
        },
        {
          name: 'menu.adminEvents',
          pathName: 'membership-ListEvent',
          icon: mdiCalendar,
        },
        {
          name: 'menu.adminIncidents',
          pathName: 'membership-ListIncident',
          icon: mdiShieldAccount,
        },
      ],
      clientAdminsMenuItems: [
        {
          name: 'menu.adminClientLists',
          pathName: 'membership-AdminClientLists',
          icon: mdiAccountDetails,
        },
      ],
      administratorsMenuItems: [
        {
          name: 'menu.adminUserManagement',
          pathName: 'membership-UserManagementHome',
          icon: mdiAccountMultiple,
        },
        {
          name: 'menu.adminAuth',
          pathName: 'AdminAuth',
          icon: mdiAccount,
        },
      ],
    };
  },
};
